import { DatePicker } from 'antd-mobile';
import React, { useEffect, useState, useCallback } from 'react';
import { formatTime } from '@/utils/getTIme';
import s from './index.module.scss';
import { cloneDeep } from 'lodash';
import moment from 'moment';
const DateForm = (props) => {
    const [visible, setVisible] = useState(false);
    const [startTimeVisible, setStartTimeVisible] = useState(false);
    const [endTimeVisible, setEndTimeVisible] = useState(false);
    let { setting = {}, updated, desc, formInstance } = props,
        { type, showTime } = setting;
    const disabled = updated !== 0;
    const [ranageTime, setRanageTime] = useState([]);

    const [rangeStartTime, setRangeStartTime] = useState(null);
    const [rangeEndTime, setRangeEndTime] = useState(null);
    const selectItem = (fn) => {
        if (!disabled) {
            fn(true);
        }
        return false;
    };

    const labelRenderer = useCallback((type, data) => {
        switch (type) {
            case 'year':
                return data + '年';
            case 'month':
                return data + '月';
            case 'day':
                return data + '日';
            case 'hour':
                return data + '时';
            case 'minute':
                return data + '分';
            case 'second':
                return data + '秒';
            default:
                return data;
        }
    }, []);

    //设置回显时间值
    const [checkedValue, setCheckedValue] = useState(null);
    const renderDataItem = (precision_str, format_str) => {
        return (
            <DatePicker
                visible={visible}
                onClose={() => {
                    setVisible(false);
                }}
                value={checkedValue ? new Date(checkedValue) : null}
                precision={precision_str}
                min={new Date('1900-01-01')}
                max={new Date('2100-12-31')}
                onConfirm={(val) => {
                    setCheckedValue(moment(val).format(format_str));
                    formInstance.setFieldsValue({
                        [props.en_name]: moment(val).format(format_str)
                    });
                }}
                renderLabel={labelRenderer}
            >
                {(value) => {
                    return (
                        <div
                            onClick={() => {
                                selectItem(setVisible);
                            }}
                            className={`${value && value.getTime() > 0 ? s['dynamic-value'] : s['dynamic-cascade-item']}`}
                        >
                            {value && value.getTime() > 0 ? formatTime(value.getTime(), format_str) : desc || '请选择时间'}
                        </div>
                    );
                }}
            </DatePicker>
        );
    };
    const showDatePicker = () => {
            if (showTime === 1) {
                return renderDataItem('year', 'YYYY');
            } else if (showTime === 2) {
                return renderDataItem('month', 'YYYY-MM');
            } else if (showTime === 3) {
                return renderDataItem('day', 'YYYY-MM-DD');
            }
            return renderDataItem('second', 'YYYY-MM-DD HH:mm:ss');
        },
        renderRangeTimeItem = (precision_str, format_str) => {
            let times = cloneDeep(ranageTime);
            return (
                <div className={s['range-time-wrap']}>
                    <DatePicker
                        visible={startTimeVisible}
                        onClose={() => {
                            setStartTimeVisible(false);
                        }}
                        value={rangeStartTime ? new Date(rangeStartTime) : null}
                        precision={precision_str}
                        min={new Date('1900-01-01')}
                        max={rangeEndTime ? new Date(rangeEndTime) : new Date('2100-12-31')}
                        onConfirm={(val) => {
                            times.unshift(moment(val).format(format_str));
                            setRanageTime(times);
                            setRangeStartTime(moment(val).format(format_str));
                            formInstance.setFieldsValue({
                                [props.en_name]: times
                            });
                        }}
                        renderLabel={labelRenderer}
                    >
                        {(value) => {
                            return (
                                <div
                                    onClick={() => {
                                        selectItem(setStartTimeVisible);
                                    }}
                                    className={`${value && value.getTime() > 0 ? s['dynamic-value'] : s['dynamic-cascade-item']}`}
                                >
                                    {value && value.getTime() > 0 ? formatTime(value.getTime(), format_str) : desc || '请选择开始时间'}
                                </div>
                            );
                        }}
                    </DatePicker>
                    -
                    <DatePicker
                        visible={endTimeVisible}
                        onClose={() => {
                            setEndTimeVisible(false);
                        }}
                        value={rangeEndTime ? new Date(rangeEndTime) : null}
                        precision={precision_str}
                        min={new Date(rangeStartTime) || new Date('1900-01-01')}
                        max={new Date('2100-12-31')}
                        onConfirm={(val) => {
                            times.push(moment(val).format(format_str));
                            setRanageTime(times);
                            setRangeEndTime(moment(val).format(format_str));
                            formInstance.setFieldsValue({
                                [props.en_name]: times
                            });
                        }}
                        renderLabel={labelRenderer}
                    >
                        {(value) => {
                            return (
                                <div
                                    onClick={() => {
                                        selectItem(setEndTimeVisible);
                                    }}
                                    className={`${value && value.getTime() > 0 ? s['dynamic-value'] : s['dynamic-cascade-item']}`}
                                >
                                    {value && value.getTime() > 0 ? formatTime(value.getTime(), format_str) : desc || '请选择结束时间'}
                                </div>
                            );
                        }}
                    </DatePicker>
                </div>
            );
        },
        showRangePicker = () => {
            if (showTime === 1) {
                return renderRangeTimeItem('year', 'YYYY');
            } else if (showTime === 2) {
                return renderRangeTimeItem('month', 'YYYY-MM');
            } else if (showTime === 3) {
                return renderRangeTimeItem('day', 'YYYY-MM-DD');
            }
            return renderRangeTimeItem('second', 'YYYY-MM-DD HH:mm:ss');
        };
    useEffect(() => {
        if (type === 'range') {
            setRangeStartTime(props.value?.length > 1 ? props.value[0] : null);
            setRangeEndTime(props.value?.length > 1 ? props.value[1] : null);
        } else {
            setCheckedValue(props.value || null);
        }
    }, []);
    return <>{type === 'range' ? showRangePicker() : showDatePicker()}</>;
};

export default DateForm;
